(function() {
  exports.BaseNeDB = (function() {
    function BaseNeDB() {}

    BaseNeDB.prototype.initialize = function(data, callback) {
      if (callback == null) {
        callback = function() {
          return void 0;
        };
      }
      this.db = new nedb();
      return this.db.insert(data, callback);
    };

    return BaseNeDB;

  })();

}).call(this);
